import React from 'react';
import GrayTag from './_base/GrayTag';

export default function ProjectTag(props) {
  return (
    <GrayTag label="PROJECT" />
  );
}
